import { useRequest } from "ahooks";
import { CustomCascader } from "Components/CustomCascader";
import { AdminContext } from "context/adminContext";
import { NotificationContext } from "context/notificationContext";
import { getCategories } from "helpers/backend_helper";
import { getTreeItems } from "helpers/helper";
import { useContext, useEffect, useState } from "react";

type Props = { value: number[]; onGroupIdChange: (ids: number[]) => void; isDisabled: boolean };
export const CascaderComponent = ({ value, onGroupIdChange, isDisabled }: Props) => {
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const { localCountry } = useContext(AdminContext);
  const [categoriesTree, setCategoriesTree] = useState<any[]>([]);

  const { loading, data } = useRequest(() => getCategories(localCountry?.iso, true), {
    refreshDeps: [localCountry],
    ready: !!localCountry?.iso,
    onError: (error: any) => {
      openNotificationWithIcon("error", error.response?.data?.message || error.message);
    },
  });

  // const categoryTreeData = useMemo(() => {
  //   if (categoriesTree && categoriesTree.length && groupId)
  //     return findCategoryTreeById(groupId, categoriesTree)?.reverse();
  // }, [categoriesTree, groupId]);
  useEffect(() => {
    if (data) {
      const treeData = data?.map((el) => getTreeItems(el));
      setCategoriesTree(treeData);
    }
  }, [data]);

  return (
    <CustomCascader
      disabled={isDisabled}
      loading={loading || !data}
      changeOnSelect={false}
      expandTrigger="hover"
      size="large"
      displayRender={(label) => label.join(" / ")}
      placeholder="Choose Category"
      options={categoriesTree}
      value={value}
      onChange={(v) => {
        onGroupIdChange(v);
      }}
    />
  );
};
